import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import type { EventDetail } from "../../types/event-detail";

export const getEventDetail = async (eventUuid: string): Promise<EventDetail | null> => {
  const res = await axiosClient.get<ApiResponse<EventDetail>>(
    `${API_ROUTES.EVENT_DETAIL}${eventUuid}/`
  );
  return res?.data?.data ?? null;
};
